<template>
  <div>
    <Top />
    <div class="home">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <span class="fl" style="line-height: 40px;margin-left:20px;">当前位置：</span>
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>合作伙伴</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="wk_scrollcontainer">
        <div class="wk_case_list">
          <a href="http://www.stats.gov.cn/" target="_blank">
            <div class="wk_case_img">
              <img src="@/assets/imgs/logo1.png" />
            </div>
            <div class="wk_case_ico"></div>
            <div class="wk_case_xian">
              <span class="wk_span_1"></span>
              <span class="wk_span_2"></span>
              <span class="wk_span_3"></span>
              <span class="wk_span_4"></span>
            </div>
          </a>
        </div>
        <div class="wk_case_list">
          <a href="http://www.customs.gov.cn/" target="_blank">
            <div class="wk_case_img">
              <img src="@/assets/imgs/logo22.png" />
            </div>
            <div class="wk_case_ico"></div>
            <div class="wk_case_xian">
              <span class="wk_span_1"></span>
              <span class="wk_span_2"></span>
              <span class="wk_span_3"></span>
              <span class="wk_span_4"></span>
            </div>
          </a>
        </div>
        <div class="wk_case_list">
          <a href="http://sg.km.gov.cn/" target="_blank">
            <div class="wk_case_img">
              <img src="@/assets/imgs/logo11.png" />
            </div>
            <div class="wk_case_ico"></div>
            <div class="wk_case_xian">
              <span class="wk_span_1"></span>
              <span class="wk_span_2"></span>
              <span class="wk_span_3"></span>
              <span class="wk_span_4"></span>
            </div>
          </a>
        </div>
        <div class="wk_case_list">
          <a href='https://www.chinaisa.org.cn' target="_blank">
            <div class="wk_case_img">
              <img src="@/assets/imgs/logo3.png" />
            </div>
            <div class="wk_case_ico"></div>
            <div class="wk_case_xian">
              <span class="wk_span_1"></span>
              <span class="wk_span_2"></span>
              <span class="wk_span_3"></span>
              <span class="wk_span_4"></span>
            </div>
          </a>
        </div>
        <div class="wk_case_list">
          <a href="http://www.caam.org.cn/" target="_blank">
            <div class="wk_case_img">
              <img src="@/assets/imgs/logo4.png" />
            </div>
            <div class="wk_case_ico"></div>
            <div class="wk_case_xian">
              <span class="wk_span_1"></span>
              <span class="wk_span_2"></span>
              <span class="wk_span_3"></span>
              <span class="wk_span_4"></span>
            </div>
          </a>
        </div>
        <div class="wk_case_list">
          <a href="http://www.cnlic.org.cn/" target="_blank">
            <div class="wk_case_img">
              <img src="@/assets/imgs/logo5.png" />
            </div>
            <div class="wk_case_ico"></div>
            <div class="wk_case_xian">
              <span class="wk_span_1"></span>
              <span class="wk_span_2"></span>
              <span class="wk_span_3"></span>
              <span class="wk_span_4"></span>
            </div>
          </a>
        </div>
        <div class="wk_case_list">
          <a href="http://www.cmisi.com.cn/" target="_blank">
            <div class="wk_case_img">
              <img src="@/assets/imgs/logo6.png" />
            </div>
            <div class="wk_case_ico"></div>
            <div class="wk_case_xian">
              <span class="wk_span_1"></span>
              <span class="wk_span_2"></span>
              <span class="wk_span_3"></span>
              <span class="wk_span_4"></span>
            </div>
          </a>
        </div>
        <div class="wk_case_list">
          <a href="http://cmif.mei.net.cn/" target="_blank">
            <div class="wk_case_img">
              <img src="@/assets/imgs/logo7.png" />
            </div>
            <div class="wk_case_ico"></div>
            <div class="wk_case_xian">
              <span class="wk_span_1"></span>
              <span class="wk_span_2"></span>
              <span class="wk_span_3"></span>
              <span class="wk_span_4"></span>
            </div>
          </a>
        </div>
        <div class="wk_case_list">
          <a href="http://www.cec.org.cn/" target="_blank">
            <div class="wk_case_img">
              <img src="@/assets/imgs/logo8.png" />
            </div>
            <div class="wk_case_ico"></div>
            <div class="wk_case_xian">
              <span class="wk_span_1"></span>
              <span class="wk_span_2"></span>
              <span class="wk_span_3"></span>
              <span class="wk_span_4"></span>
            </div>
          </a>
        </div>
        <div class="wk_case_list">
          <a href="http://www.cbmf.org/" target="_blank">
            <div class="wk_case_img">
              <img src="@/assets/imgs/logo9.png" />
            </div>
            <div class="wk_case_ico"></div>
            <div class="wk_case_xian">
              <span class="wk_span_1"></span>
              <span class="wk_span_2"></span>
              <span class="wk_span_3"></span>
              <span class="wk_span_4"></span>
            </div>
          </a>
        </div>
        <div class="wk_case_list">
          <a href="http://cpcia.org.cn" target="_blank">
            <div class="wk_case_img">
              <img src="@/assets/imgs/logo10.png" />
            </div>
            <div class="wk_case_ico"></div>
            <div class="wk_case_xian">
              <span class="wk_span_1"></span>
              <span class="wk_span_2"></span>
              <span class="wk_span_3"></span>
              <span class="wk_span_4"></span>
            </div>
          </a>
        </div>

        <div class="wk_case_list">
          <a href="http://jjxy.jlu.edu.cn/" target="_blank">
            <div class="wk_case_img">
              <img src="@/assets/imgs/logo12.png" />
            </div>
            <div class="wk_case_ico"></div>
            <div class="wk_case_xian">
              <span class="wk_span_1"></span>
              <span class="wk_span_2"></span>
              <span class="wk_span_3"></span>
              <span class="wk_span_4"></span>
            </div>
          </a>
        </div>

        <div class="wk_case_list">
          <a href="http://www.ccoic.cn" target="_blank">
            <div class="wk_case_img">
              <img src="@/assets/imgs/nlogo1.png" />
            </div>
            <div class="wk_case_ico"></div>
            <div class="wk_case_xian">
              <span class="wk_span_1"></span>
              <span class="wk_span_2"></span>
              <span class="wk_span_3"></span>
              <span class="wk_span_4"></span>
            </div>
          </a>
        </div>

        <div class="wk_case_list">
          <a href="http://obor.bisu.edu.cn" target="_blank">
            <div class="wk_case_img">
              <img src="@/assets/imgs/nlogo2.png" />
            </div>
            <div class="wk_case_ico"></div>
            <div class="wk_case_xian">
              <span class="wk_span_1"></span>
              <span class="wk_span_2"></span>
              <span class="wk_span_3"></span>
              <span class="wk_span_4"></span>
            </div>
          </a>
        </div>

        <div class="wk_case_list">
          <a href="http://www.clic.org.cn" target="_blank">
            <div class="wk_case_img">
              <img src="@/assets/imgs/nlogo3.png" />
            </div>
            <div class="wk_case_ico"></div>
            <div class="wk_case_xian">
              <span class="wk_span_1"></span>
              <span class="wk_span_2"></span>
              <span class="wk_span_3"></span>
              <span class="wk_span_4"></span>
            </div>
          </a>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style lang='scss' scoped>
.el-breadcrumb {
  background: #f3f5f7;
  margin-top: 30px;
}
.el-breadcrumb__item {
  line-height: 40px;
}
/* 合作伙伴 */
.wk_scrollcontainer {
  height: 700px;
  position: relative;
  overflow: hidden;
  width: 1200px;
  padding-top: 40px;
}
.wk_case_list {
  position: relative;
  border: 1px solid #ccc;
  float: left;
  overflow: hidden;
  margin: 0 20px 20px 0;
  width: 220px;
  height: 120px;
  background: #fff;
  .wk_case_img {
    position: relative;
    width: 216px;
    height: 120px;
    img {
      margin: 20px auto;
      width: 126px;
      display: block;
      height: 80px;
    }
  }
  .wk_case_ico {
    position: absolute;
    top: 0;
    left: 0;
    width: 220px;
    height: 120px;
    background: url(../assets/images/case_ico.png) no-repeat center;
    opacity: 0;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    -o-transition: all 0.3s;
    transition: all 0.3s;
    -webkit-opacity: 0;
    -moz-opacity: 0;
  }
  .wk_case_xian {
    position: absolute;
    top: 16px;
    left: 16px;
    width: 183px;
    height: 85px;
  }
  span {
    position: absolute;
    background: #0ddfba;
    -webkit-transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    -moz-transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    -o-transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
  .wk_span_1 {
    top: 0;
    left: 0;
    width: 0;
    height: 2px;
  }
  .wk_span_2 {
    top: 0;
    right: 0;
    width: 2px;
    height: 0;
  }
  .wk_span_3 {
    right: 0;
    bottom: 0;
    width: 0;
    height: 2px;
  }
  .wk_span_4 {
    bottom: 0;
    left: 0;
    width: 2px;
    height: 0;
  }
}

.wk_case_list:hover .wk_case_ico {
  opacity: 1;
  -webkit-opacity: 1;
  -moz-opacity: 1;
}

.wk_case_list:hover .wk_span_1,
.wk_case_list:hover .wk_span_3 {
  width: 100%;
}

.wk_case_list:hover .wk_span_2,
.wk_case_list:hover .wk_span_4 {
  height: 100%;
}
</style>